/*
 * @providesModule LoadableComponent
   
 */

import React from 'react';

import {ActivityIndicator, ActivityIndicatorProps, View, ViewStyle} from 'react-native';
import SKZLayoutAnimations from 'SKZLayoutAnimations';

interface Props {
  shouldRender: () => boolean;
  renderChildren?: () => React.ReactNode;
  indicatorProps?: ActivityIndicatorProps;
  style?: ViewStyle;
}

// This component can be used to automatically display an activity indicator while loading.
export default class LoadableComponent extends React.Component<Props, {}> {
  hasRendered: boolean;

  constructor(props: Props) {
    super(props);

    this.hasRendered = false;
  }

  shouldRender(): boolean {
    if (this.props.shouldRender) {
      return this.props.shouldRender();
    }

    return false;
  }

  render(): React.ReactNode {
    if (this.shouldRender()) {
      if (!this.hasRendered) {
        this.hasRendered = true;
        SKZLayoutAnimations.easeInEaseOut();
      }
      if (this.props.renderChildren) {
        return this.props.renderChildren();
      }
      return this.props.children;
    }

    return (
      <View style={this.props.style}>
        <ActivityIndicator {...this.props.indicatorProps} />
      </View>
    );
  }
}
